<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Compras Pendientes por Recibir (En Tránsito)
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL">
				<i class="bx bxs-shopping-bag"></i>Pendientes de Recibir
			</label>
		</div>
		<app-history-purchases-pending [hidden]="history!=0"></app-history-purchases-pending>
	</div>
</div>